import { render } from "./AuthenticationCardLogo.vue?vue&type=template&id=48b4750f"
const script = {}

import "./AuthenticationCardLogo.vue?vue&type=style&index=0&id=48b4750f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__